// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroll-container {
    position: relative;
    width: 100%;
    height: fit-content;
}

.scroll-content {
    width: 100%;
    height: fit-content;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-x: auto;
    transform: rotateX(180deg);
    cursor: grab;
}

.scroll-container:active {
    cursor: grabbing;
}

.scroll-content .content {
    display: flex;
    flex-direction: row;
    transform: rotateX(180deg);
}

.hidden-scroll {
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;  /* Firefox */
}
.hidden-scroll::-webkit-scrollbar {
    display: none;  /* Safari and Chrome */
}

.w-fit-content {
    width: fit-content;
}

.button-imitation {
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/scroll.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB,GAAG,0BAA0B;IACrD,qBAAqB,GAAG,YAAY;AACxC;AACA;IACI,aAAa,GAAG,sBAAsB;AAC1C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".scroll-container {\n    position: relative;\n    width: 100%;\n    height: fit-content;\n}\n\n.scroll-content {\n    width: 100%;\n    height: fit-content;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    overflow-x: auto;\n    transform: rotateX(180deg);\n    cursor: grab;\n}\n\n.scroll-container:active {\n    cursor: grabbing;\n}\n\n.scroll-content .content {\n    display: flex;\n    flex-direction: row;\n    transform: rotateX(180deg);\n}\n\n.hidden-scroll {\n    -ms-overflow-style: none;  /* Internet Explorer 10+ */\n    scrollbar-width: none;  /* Firefox */\n}\n.hidden-scroll::-webkit-scrollbar {\n    display: none;  /* Safari and Chrome */\n}\n\n.w-fit-content {\n    width: fit-content;\n}\n\n.button-imitation {\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
